import { getFingerprint, setOption } from '@thumbmarkjs/thumbmarkjs';

let browserFingerprint = null as string | null;

export async function initializeBrowserFingerprint() {
    try {
        // Permissions takes up to 30ms in fetching
        // We want to keep it as fast as possible
        setOption('exclude', ['permissions']);
        setOption('timeout', 300);

        browserFingerprint = await getFingerprint();
    } catch (e) {
        // We don't want to crash the app if we can't get the fingerprint
        // This is probably an expected behavior in some cases
        browserFingerprint = null;
    }
}

export function getBrowserFingerprint() {
    return browserFingerprint;
}
